export default __webpack_public_path__ + "static/media/google-drive.91b41cc0.png";